<template>
  <div class="repassword-page">
    <v-container class="mt-4" fluid fill-height>
      <v-row align="center" justify="center">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="8" md="6">
          <v-card class="elevation-12">
            <v-toolbar dark v-bind:class="[isValis ? 'header-color-valis' : isCpmMode ? 'header-color-cpm-rakuten' : 'header-color']">
              <v-toolbar-title class="toolbar-title">{{ $t("repassword.title") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="!isComplete">
              {{ $t("repassword.message") }}
              <v-form ref="form" v-model="valid" lazy-validation browser-autocomplete="off">
                <v-text-field
                  prepend-icon="mdi-account"
                  v-model="email"
                  :rules="emailRules"
                  :label="$t('repassword.form.email.label')"
                  disabled
                  variant="underlined"
                ></v-text-field>
                <v-text-field
                  v-model="verificationCode"
                  autocomplete="new-verification-code"
                  :rules="codeRules"
                  :label="$t('repassword.form.verificationCode.label')"
                  required
                  variant="underlined"
                ></v-text-field>
                <v-text-field
                  prepend-icon="mdi-lock"
                  v-model="password"
                  autocomplete="new-password"
                  :append-icon="pwdflg ? 'visibility' : 'visibility_off'"
                  :type="pwdflg ? 'text' : 'password'"
                  :label="$t('repassword.form.password.label')"
                  counter
                  :rules="passwordRules"
                  required
                  @click:append="pwdflg = !pwdflg"
                  variant="underlined"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-alert v-if="error" :value="true" outlined color="error" type="error">
                  <span v-html="error"></span>
                </v-alert>
                <v-btn :disabled="!valid" @click="rePasswordButtonClick">{{ $t("repassword.submit") }}</v-btn>
              </v-form>
              <div class="text-right">
                <router-link :to="'login'">{{$t("repassword.back") }}</router-link>
              </div>
            </v-card-text>
            <v-card-text v-if="isComplete">
              {{ $t("repassword.complete") }}
              <div class="tex-right">
                <router-link :to="'login'">{{ $t("repassword.back") }}</router-link>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'RePassword',
  data: function () {
    return {
      isComplete: false,
      valid: true,
      email: '',
      emailRules: [
        (v) => !!v || this.$t('commons.validation.email.required'),
        (v) => /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || this.$t('commons.validation.email.invalid')
      ],
      password: '',
      passwordRules: [
        (v) => !!v || this.$t('commons.validation.password.required'),
        (v) => v.length >= 12 || this.$t('commons.validation.password.short'),
        (v) => /(?=.*[a-z]+)(?=.*[A-Z]+)(?=.*[0-9]+)(?=^[a-zA-Z0-9]+$)/.test(v) || this.$t('commons.validation.password.formatter')
      ],
      verificationCode: '',
      codeRules: [(v) => !!v || this.$t('commons.validation.verificationCode.required')],
      pwdflg: false,
      error: undefined,
      isValis: false,
      isCpmMode: false
    }
  },
  methods: {
    ...mapActions('auth', ['rePassword', 'setLoginError', 'setupdateEmail']),
    rePasswordButtonClick: function () {
      if (this.$refs.form.validate()) {
        this.error = null
        this.rePassword({
          email: this.email,
          code: this.verificationCode,
          password: this.password
        })
          .then((result) => {
            this.error = undefined
            this.setLoginError('')
            this.setupdateEmail(undefined)
            this.isComplete = true
          })
          .catch((err) => {
            switch (err.code) {
              case 'NotAuthorizedException':
                this.error = this.$t('commons.cognito.notAuthorized', [err.message])
                break
              case 'InvalidParameterException':
                this.error = this.$t('commons.cognito.invalidParam', [err.message])
                break
              case 'InvalidPasswordException':
              case 'UserNotFoundException':
                this.error = this.$t('commons.cognito.invalidUser', [err.message])
                break
              case 'LimitExceededException':
                this.error = this.$t('commons.cognito.limitExceeded', [err.message])
                break
              case 'ExpiredCodeException':
                this.error = this.$t('commons.cognito.expiredCode', [err.message])
                break
              case 'CodeMismatchException':
                this.error = this.$t('commons.cognito.invalidCode', [err.message])
                break
              default:
                this.error = this.$t('commons.cognito.otherAuthError', [err.message])
                break
            }
          })
        this.setLoginError(this.error)
      }
    },
    getStoreForgetEmail: function () {
      if (!this.$store.getters['auth/updateEmail']) {
        this.$router.replace('/error')
      }

      return this.$store.getters['auth/updateEmail']
    }
  },
  mounted: function () {
    if (process.env.ProjectCode === '301') {
      this.isValis = true
    } else if (process.env.ProjectCode === '111') {
      this.isCpmMode = true
    }
    this.email = this.getStoreForgetEmail()
  }
}
</script>
<style scoped>
.header-color {
  background-color: #4b7001 !important;
}
.header-color-valis {
  background-color: #093493 !important;
}
.header-color-cpm-rakuten {
  background-color: #BF0000 !important;
}
.repassword-page {
  min-height: 100%;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}
.toolbar-title {
  color: #FFFFFF !important;
}
</style>
